export default {
    Metadata: {
        Name: "Contains",
        Description: "Returns True if the find_string is found inside the search_string, otherwise returns false.",
        Syntax: "Contains(search_string, find_string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(searchStr, findStr) {
        if (searchStr != null && findStr != null) {
            return searchStr.indexOf(findStr) >= 0;
        }
        else {
            return false;
        }
    },
};

